import React from "react";
import { Oval, Bars, ThreeDots, FallingLines } from "react-loader-spinner";

export const InnerSpinner = ({
  color = "#EAC024",
  type = "threeDots",
  width = 70,
  height = 100,
}) => {
  const types = {
    audio: <Oval color={color} width={width} height={40} visible={true} />,
    bars: <Bars color={color} width={width} visible={true} />,
    threeDots: (
      <ThreeDots color={color} width={width} height={height} visible={true} />
    ),
    fallingLines: <FallingLines color={color} width="50" visible={true} />,
  };

  return (
    <div className="mt-4 z-100 flex">
      <div>{types[type]}</div>
    </div>
  );
};

export default InnerSpinner;
